<template>
	<div class="page" v-loading="loading">
		<el-breadcrumb>
			<el-breadcrumb-item>商品管理</el-breadcrumb-item>
			<el-breadcrumb-item>我的收藏</el-breadcrumb-item>
		</el-breadcrumb>

		<el-form :inline="true" class="top">
			<el-form-item>
				<el-input v-model="keyword" placeholder="搜索商品名称/ID/标签" size="mini"></el-input>
			</el-form-item>
			<!-- <el-form-item>
				<el-input placeholder="体检预约" size="mini"></el-input>
			</el-form-item> -->
			<el-form-item>
				<el-button type="primary" size="mini" @click="toSearch">查询</el-button>
			</el-form-item>
			<el-form-item>
				<el-button type="success" size="mini" @click="refresh">刷新</el-button>
			</el-form-item>
		</el-form>

		<el-table :data="tableData" :header-cell-style="{background:'#F5F5F5'}" size="mini"
			style="width: 100%; margin-bottom: 20px;" stripe border>
			<el-table-column type="index" label="序号" width="80"></el-table-column>
			<el-table-column prop="ext" label="所属康家 ">
				<template slot-scope="scope">
					{{ scope.row.store ? scope.row.store : '' }}
				</template>
			</el-table-column>
			<el-table-column prop="thumb" label="商品主图">
				<template slot-scope="scope">
					<el-image style="width: 80px; height: 80px;" :src="scope.row.thumb" fit="contain"></el-image>
				</template>
			</el-table-column>
			<el-table-column label="商品信息" width="300">
				<template slot-scope="scope">
					<p>ID:{{ scope.row.good_no }}</p>
					<p>{{ scope.row.title }}</p>
				</template>
			</el-table-column>
			<el-table-column prop="original_price" label="原价"></el-table-column>
			<el-table-column prop="guide_price" label="官方指导价"></el-table-column>
			<el-table-column prop="sale_price" label="日常价"></el-table-column>
			<el-table-column prop="active_price" label="普通活动价">
				<template slot-scope="scope">
					{{ scope.row.active_price ? scope.row.active_price :'无' }}
				</template>
			</el-table-column>
			<el-table-column prop="year_end_price" label="年终/大促">
				<template slot-scope="scope">
					{{ scope.row.year_end_price ? scope.row.year_end_price :'无' }}
				</template>
			</el-table-column>
			<el-table-column prop="vip_agent_price" label="VIP代理"></el-table-column>
			<el-table-column prop="pt_agent_price" label="铂金代理"></el-table-column>
			<el-table-column prop="do_agent_price" label="钻石代理"></el-table-column>
			<el-table-column label="是否收藏">
				<template slot-scope="scope">
					<el-switch v-model="collection[scope.$index]" active-color="#0CC428"
						@change="onCollection(scope.$index,scope.row.goods_id)">
					</el-switch>
				</template>
			</el-table-column>
			<el-table-column label="分享/推广" width="220">
				<template slot-scope="scope">
					<p v-if="linkShow  && linkid == scope.row.id">{{ link }}</p>
					<el-button type="primary" round size="mini" @click="onCopy(scope.row.id,scope.row.spid)">复制链接
					</el-button>
				</template>
			</el-table-column>
		</el-table>

		<el-pagination background layout="prev,pager,next,total" :page-count="maxpage" :total="total" :page-size="15"
			@current-change="pageChange"></el-pagination>
	</div>
</template>

<script>
	export default {
		name: 'Collection',
		data() {
			return {
				loading: false,
				keyword: '',
				tableData: [],
				page: 1,
				maxpage: 1,
				total: 0,
				collection: [],
				link: '',
				linkShow: false,
				linkid: '',
			}
		},
		methods: {
			getData() {
				this.loading = true
				this.tableData = []
				this.$util.get('agent/getGoodsCollect', {
						name: this.keyword
					})
					.then(res => {
						this.loading = false
						this.tableData = res.data
						this.total = res.total
						for (let i = 0; i < res.data.length; i++) {
							this.collection[i] = true
						}
					})
			},
			pageChange(page) {
				this.tableData = []
				this.page = page
				this.getData()
			},
			toSearch() {
				this.page = 1
				this.maxpage = 1
				this.total = 0
				this.tableData = []
				this.getData()
			},
			refresh() {
				this.getData()
			},
			onCopy(id, spid) {
				this.link = "http://m.huarendjk.com/productdetails?id=" + id + "&spid=" + spid
				var input = document.createElement("input");
				input.value = this.link;
				this.linkShow = true
				this.linkid = id
				document.body.appendChild(input);
				input.select();
				document.execCommand("Copy");
				this.$alert("复制成功");
			},
		},
		activated() {
			this.getData()
		}
	}
</script>

<style scoped>
	.el-table /deep/ .has-gutter th .cell {
		text-align: center;
	}

	.el-table /deep/ .cell {
		text-align: center;
	}

	.el-table /deep/ .el-table__row .el-table_1_column_4 p {
		text-align: left;
	}

	.top {
		margin-top: 30px;
	}
</style>
